import { Component,OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';
@Component({
  selector: 'app-bulk-sms-sender',
  templateUrl: './bulk-sms-sender.component.html',
  styleUrls: ['./bulk-sms-sender.component.scss']
})
export class BulkSmsSenderComponent implements OnInit {
  
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('Bulk Messenger');

    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
